import React from 'react';
import Styles from './BlogSubmenu.module.less';
import { BlogSubmenuLinks, MenuItem } from './BlogSubmenuLinks';
import { useToggler } from '../../../lib';
import { faSearch, faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '../../FontAwesomeIcon';
import {
    BlogSearchForm,
    BlogSearchFormProps,
} from '../BlogSearchForm/BlogSearchForm';

export type BlogSubmenuProps = BlogSearchFormProps & {
    items: MenuItem[];
    selected?: string;
};

export const BlogSubmenuDesktop = ({
    items,
    searchTerm,
    onSearch,
    selected,
}: BlogSubmenuProps) => {
    const [isSearchOpen, toggleSearch] = useToggler(false);
    return (
        <div className={Styles.container}>
            <div className={Styles.submenu}>
                {!isSearchOpen && (
                    <div className={Styles.options}>
                        <BlogSubmenuLinks
                            homeTitle="Blog"
                            items={items}
                            selected={selected}
                        />
                    </div>
                )}
                {isSearchOpen ? (
                    <>
                        <BlogSearchForm
                            searchTerm={searchTerm}
                            onSearch={onSearch}
                            autoFocus={true}
                        />
                        <div onClick={toggleSearch} className={Styles.search}>
                            <FontAwesomeIcon icon={faTimes} />
                        </div>
                    </>
                ) : (
                    <div onClick={toggleSearch} className={Styles.search}>
                        Procurar <FontAwesomeIcon icon={faSearch} />
                    </div>
                )}
            </div>
        </div>
    );
};
